import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * جداکننده بخش‌های یک سطر توضیح («۳۶ ماهه، سود ۱۸٪»). «،» و نه «·»: نقطه وسط کنار رقم فارسی
 * «۰» خوانده می‌شود (۲۴ · ماهه ← «۲۴۰»)، «|» شبیه «۱» است و خط تیره شبیه بازه/منفی؛ ویرگول
 * در همه قلم‌های سایت یکتاست و صفحه‌خوان هم آن را مکث می‌خواند.
 * نشانه نامرئی RLM پیش از ویرگول: میان دو متن لاتین («آریا E، TK-۰۴۱۹») ویرگول خنثی جزو متن
 * چپ‌به‌راست می‌شد و دو بخش جابه‌جا دیده می‌شدند.
 */
export const SEP = "‏، ";

/**
 * برچسب فیلد فرم از روی name آن (کیت فرم name را روی ورودی و برچسب را با htmlFor می‌گذارد)؛
 * اول در آخرین دیالوگ باز، بعد کل صفحه. برای toast خطای «کدام فیلد چه مشکلی دارد».
 */
export const fieldLabel = (name: string) => {
  if (!name || !("document" in globalThis)) return undefined;
  const selector = `[name="${CSS.escape(name)}"]`;
  const dialogs = document.querySelectorAll('[role="dialog"]');
  const control =
    dialogs[dialogs.length - 1]?.querySelector(selector) ?? document.querySelector(selector);
  const isControl =
    control instanceof HTMLInputElement ||
    control instanceof HTMLSelectElement ||
    control instanceof HTMLTextAreaElement;
  return (isControl && control.labels?.[0]?.textContent?.trim()) || undefined;
};
